import dayjs from 'dayjs';
import { isPS } from './system';

export const getCurrentFiscalYear = () => {
  const now = dayjs();
  const year = now.year();
  // 暫定対応 https://linear.app/wise-vine/issue/PRZ-1688/feat：公開サイトの年度の検索条件の初期値を2024年に一旦固定する
  if (isPS()) {
    return 2024;
  }
  const month = now.month() + 1;
  if (month <= 3) {
    return year - 1;
  }
  return year;
};

// 指定された年度が開始年度と終了年度の範囲内にあるかを判定する
export const isTargetYearWithinFiscalYearRange = ({
  targetYear,
  startYear,
  endYear,
}: {
  targetYear: number | null | undefined;
  startYear: number | null | undefined;
  endYear: number | null | undefined;
}): boolean => {
  if (typeof targetYear !== 'number') {
    return true;
  }
  if (typeof startYear === 'number' && typeof endYear === 'number') {
    return targetYear >= startYear && targetYear <= endYear;
  }
  if (typeof startYear === 'number') {
    return targetYear >= startYear;
  }
  if (typeof endYear === 'number') {
    return targetYear <= endYear;
  }
  return true;
};
